import { render, staticRenderFns } from "./TabelaDeDados.vue?vue&type=template&id=0013e468&scoped=true"
import script from "./TabelaDeDados.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeDados.vue?vue&type=style&index=0&id=0013e468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013e468",
  null
  
)

export default component.exports